import { apiService } from '@/services/ApiService.ts';
import { AuthenticationService } from '@/services/AuthenticationService.ts';
import { useSessionStore } from '@/stores/SessionStore.ts';
import { useUserInfoStore } from '@/stores/UserInfoStore.ts';
import type { SubscriptionTier } from '@/types/SubscriptionTier.ts';
import { useSettingsStore } from '@/stores/SettingsStore.ts';
import { wsAuthLogIn } from '@/ws/requests/WsAuthLogIn.ts';
import { useAuthStore } from '@/stores/AuthStore.ts';
import { fetchAiModelsAction } from '@/actions/app/FetchAiModelsAction.ts';
import { router, ROUTES } from '@/router.ts';
import { requestInputSourcesAction } from '@/actions/electron/RequestInputSourcesAction.ts';

/**
 * @throws {Error} On API error response
 */
export const registerAction = async (
    username: string,
    password: string,
    captchaToken: string,
    referralSource?: string,
) => {
    const apiResponse = await apiService.getApi().authRegisterV1({
        registerRequestDto: {
            username,
            password,
            captchaToken,
            referralSource,
        },
    });

    const { refreshToken, accessTokenExpiresIn, fingerprintHash, accessToken } =
        apiResponse.tokenData;

    AuthenticationService.instance.storeTokenData(
        accessToken,
        refreshToken,
        fingerprintHash,
        accessTokenExpiresIn,
    );

    const authStore = useAuthStore();
    authStore.isLoggedIn = true;

    const { creditsRemaining, username: userUsername, subscriptionTier } = apiResponse.userData;

    const userInfoStore = useUserInfoStore();
    userInfoStore.username = userUsername;
    userInfoStore.creditsRemaining = creditsRemaining;
    userInfoStore.subscriptionTier = subscriptionTier as SubscriptionTier;

    const settingsStore = useSettingsStore();
    settingsStore.rememberedUsername = userUsername;

    // Start onboarding
    settingsStore.isOnboarding = true;

    const sessionStore = useSessionStore();
    wsAuthLogIn(accessToken, !sessionStore.isInsideWebView);

    await fetchAiModelsAction();
    void requestInputSourcesAction();

    await router.push(ROUTES.onboarding);
};
